__turbopack_context__.v({
  "caret": "NWJatq_caret",
  "caretButton": "NWJatq_caretButton",
  "colHeading": "NWJatq_colHeading",
  "column": "NWJatq_column",
  "columns": "NWJatq_columns",
  "dropdown": "NWJatq_dropdown",
  "footer": "NWJatq_footer",
  "footerButton": "NWJatq_footerButton",
  "footerLabel": "NWJatq_footerLabel",
  "footerLink": "NWJatq_footerLink",
  "footerLinks": "NWJatq_footerLinks",
  "item": "NWJatq_item",
  "itemDesc": "NWJatq_itemDesc",
  "itemTitle": "NWJatq_itemTitle",
  "menu": "NWJatq_menu",
  "toggle": "NWJatq_toggle",
  "toggleActive": "NWJatq_toggleActive",
  "toggleLink": "NWJatq_toggleLink",
});
